import { ExamProgressTag } from 'Components/exam/ExamProgressTag/ExamProgressTag'
import { AttemptStatus, ExamAttempt } from 'Types/Exams.types'
import { useMemo, useCallback } from 'react'
import { useExamTimeLimit } from './use-exam-time-limit'

type UseExamProgressProps = {
    timeLimitInSeconds?: number | null
    attempt?: ExamAttempt | null
}

export const useExamProgress = ({ timeLimitInSeconds, attempt }: UseExamProgressProps) => {
    const { getTimeLeft, isTimeLimitSet } = useExamTimeLimit({ timeLimitInSeconds, attempt })
    const isExamInProgress = attempt?.status === AttemptStatus.IN_PROGRESS

    const getTimeLeftInMins = useCallback(() => {
        if (!isTimeLimitSet) {
            return
        }
        const timeLeft = getTimeLeft()
        return timeLeft ? Math.round(timeLeft / 60) : 0
    }, [getTimeLeft, isTimeLimitSet])

    const examProgressTag = useMemo(() => {
        return isExamInProgress ? (
            <ExamProgressTag isTimeLimitSet={isTimeLimitSet} timeLeftInMins={getTimeLeftInMins()} />
        ) : null
    }, [isExamInProgress, isTimeLimitSet, getTimeLeftInMins])

    return { getTimeLeftInMins, getTimeLeftInSecs: getTimeLeft, isExamInProgress, examProgressTag }
}
